import React from "react";
import { Box } from "grommet";
import DocsItem from "./DocsItem";
export var AntiDopingDocs = function AntiDopingDocs(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/ React.createElement(
    React.Fragment,
    null,
    data.map(function (d) {
      return /*#__PURE__*/ React.createElement(
        Box,
        {
          key: d.public_id,
          flex: true,
          direction: "column",
          margin: {
            bottom: "20px",
          },
        },
        /*#__PURE__*/ React.createElement(DocsItem, {
          title: d.title,
          date: d.document_date,
          link: d.link,
        })
      );
    })
  );
};
